var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import myComments from "@irati/recognition/utils/feed/myComments";
import { IconTypes } from "@irati/ui/src/Icon";
import IconWithNumber from "./IconWithNumber";
import Tooltip, { Tip } from "../shared/Tooltip";
var CommentsIcon = /** @class */ (function (_super) {
    __extends(CommentsIcon, _super);
    function CommentsIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommentsIcon.prototype.render = function () {
        var _a = this.props, item = _a.item, onClick = _a.onClick;
        var numComments = item.comments.results.length;
        var hasComments = numComments > 0;
        var commentIcon = hasComments ? IconTypes.speech : IconTypes.speechPlus;
        var hasCommented = myComments(item).length > 0;
        return (React.createElement(Tooltip, { placement: "bottom", tip: React.createElement(Tip, { id: id("toolTip", this.props) },
                React.createElement(FormattedMessage, { id: "recognition.comments.tooltip" })) },
            React.createElement("span", null,
                React.createElement(IconWithNumber, { icon: commentIcon, number: numComments, active: hasCommented, onClick: onClick, id: id("iconWithNumber", this.props) }))));
    };
    CommentsIcon.defaultProps = {
        onClick: function () { },
        id: "commentsIconId"
    };
    return CommentsIcon;
}(PureComponent));
export default CommentsIcon;
